import type { DebugPinOverrides, ZoomBucket } from '../redux/reducer';

export const DEFAULT_DESKTOP_REGULAR_PINS: Record<ZoomBucket, number> = {
  4: 25,
  6: 25,
  8: 25,
  12: 25,
  14: 500,
  23: 500
};

export const DEFAULT_MOBILE_REGULAR_PINS: Record<ZoomBucket, number> = {
  4: 10,
  6: 15,
  8: 30,
  12: 30,
  14: 30,
  23: 30
};

export const DEFAULT_DESKTOP_COLLAPSED_PINS: Record<ZoomBucket, number> = {
  4: 0,
  6: 0,
  8: 150,
  12: 150,
  14: 0,
  23: 0 // no collapsed pins when zoomed all the way in
};

export const DEFAULT_MOBILE_COLLAPSED_PINS: Record<ZoomBucket, number> = {
  4: 0,
  6: 0,
  8: 5,
  12: 5,
  14: 5,
  23: 0 // no collapsed pins when zoomed all the way in
};

export const ZOOM_BUCKETS: ZoomBucket[] = [4, 6, 8, 12, 14, 23];

const getZoomBucketFromZoom = (zoom?: number): ZoomBucket => {
  if (zoom && zoom <= 4) return 4;
  if (zoom && zoom <= 6) return 6;
  if (zoom && zoom <= 8) return 8;
  if (zoom && zoom <= 12) return 12;
  if (zoom && zoom <= 14) return 14;
  return 23;
};

const pinZoomPopularityMap = (
  zoom?: number,
  debugOverrides?: DebugPinOverrides
): {
  maxDesktopRegularPins?: number;
  maxMobileRegularPins?: number;
  maxTotalDesktopPins?: number;
  maxTotalMobilePins?: number;
} => {
  const zoomBucket = getZoomBucketFromZoom(zoom);
  const override = debugOverrides?.[zoomBucket];

  const desktopRegular = override?.desktopRegular ?? DEFAULT_DESKTOP_REGULAR_PINS[zoomBucket];
  const mobileRegular = override?.mobileRegular ?? DEFAULT_MOBILE_REGULAR_PINS[zoomBucket];
  const desktopCollapsed = override?.desktopCollapsed ?? DEFAULT_DESKTOP_COLLAPSED_PINS[zoomBucket];
  const mobileCollapsed = override?.mobileCollapsed ?? DEFAULT_MOBILE_COLLAPSED_PINS[zoomBucket];

  return {
    maxDesktopRegularPins: desktopRegular,
    maxMobileRegularPins: mobileRegular,
    maxTotalDesktopPins: desktopRegular + desktopCollapsed,
    maxTotalMobilePins: mobileRegular + mobileCollapsed
  };
};

export default pinZoomPopularityMap;
